import React from "react";
import { DragDropManager } from '@dnd-kit/dom';
import { Sortable } from '@dnd-kit/dom/sortable';
import { useEffect, useRef } from 'react';
import "./SortableTable.css";

const mountSortable = (container, items) => {
  const manager = new DragDropManager();

  const wrapper = document.createElement('ul');
  wrapper.classList.add('sortable-list');

  manager.monitor.addEventListener('dragend', (e) => {
    if(e.canceled) return;

    const rows = Array.from(wrapper.querySelectorAll(`.sortable-list-item`)).filter((row) => row.dataset.dndPlaceholder !== "hidden");
    rows.forEach((row, index) => {
      const span = row.querySelector('.sortable-index span');

      if (span) {
        span.textContent = index + 1;
      }
    });
  });

  items.forEach((item, index) => {
    const el = document.createElement('li');
    el.classList.add('sortable-list-item');
    el.innerHTML = `<input type="hidden" name="facturas[]" value="${item.id}" />
    <div class="row">
        <div class="col sortable-index" style="max-width: 40px">☰ <span class="font-weight-bold">${index + 1}</span></div>
        <div class="col-3">${item.ncf}</div>
        <div class="col-5" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">${item.cliente}</div>
        <div class="col">${item.total}</div>
    </div>`;

    new Sortable(
      {
        id: item,
        index,
        element: el,
      },
      manager
    );

    wrapper.appendChild(el);
  });

  container.appendChild(wrapper);

  return () => {
    wrapper.remove();
    manager?.destroy?.();
  };
}

const SortableTable = ({ rows }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const cleanup = mountSortable(ref.current, rows);

    return cleanup;
  }, []);

  return <>
    <div className="w-100" style={{fontSize: "1rem"}}>
        <span style={{fontSize: '22px', fontWeight: 600}}>Orden de Entrega</span>
        <div className="row font-weight-bold" style={{padding: "10px 20px"}}>
            <div className="col" style={{maxWidth: '40px'}}>#</div>
            <div className="col-3">NCF/Factura</div>
            <div className="col-5">Contacto</div>
            <div className="col">Total</div>
        </div>
    </div>
    <div className="w-100" style={{fontSize: "1rem"}} ref={ref} />
  </>;
}

export default SortableTable;